let userInfo = {
  id: '',
  username: '',
  name: '',
  status: 1
}
let showLoginDialog = false;
let refreshHeader = false;
let isClosePage = false;
let isLogOut = false;
let userStatusChange = false;
let baseUrl = '';
let appName = '';
let appSecret = '';
let cystorageUrl = '';
let headerActive = 'home';
//判断ie11以下监听onbeforeunload 事件，监听的是离开页面事件还是父组件调用子组件的事件 1:页面离开，0:父组件调用子组件
let isLeavePage = '1';
const state = {
  userInfo,
  refreshHeader,
  isClosePage,
  isLogOut,
  userStatusChange,
  permissions: [],
  baseUrl,
  appName,
  appSecret,
  cystorageUrl,
  showLoginDialog,
  headerActive,
  isLeavePage,
  media:{
    isPlay: false, // 是否播放
    mode: '', // 资源播放格式， video, audio, image, doc
    src: '', // 资源播放地址
    poster: '', // 资源poster
    title: '', // 资源名称
    type: '' // 资源类型 video:mp4, audio: mp3
  }
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js